












import { Component, Prop, Vue } from "vue-property-decorator";
import languageIcon from "@/shared/languageIcon";

@Component
export default class LanguageDisplay extends Vue {
  @Prop() private language!: string;
  private languageIcon = languageIcon;
}
